
import { getAuthorDisplayName } from '@@/bits/author'
import { getPostPublishedAt } from '@@/bits/post_timestamps'
import { blankUser, isRegistered } from '@@/bits/user_model'
import { Component, Getter, Prop, State, Vue, namespace } from '@@/bits/vue'
import OzRelativeTime from '@@/library/v4/components/OzRelativeTime.vue'
import AvatarImage from '@@/vuecomponents/avatar_image.vue'
import emitClickOnTouch from '@@/vuedirectives/emit_click_on_touch'
import type { Tenant, User } from '@padlet/arvo'
import type { HashId, Id, Post } from '@@/types'

@Component({
  components: {
    AvatarImage,
    OzRelativeTime,
  },
  directives: {
    emitClickOnTouch,
  },
})
export default class SurfacePostAuthorNew extends Vue {
  @Prop() post!: Required<Post>
  @State tenant!: Tenant
  @State isApp!: boolean
  @Getter isStream!: boolean
  @Getter colorScheme!: 'light' | 'dark'
  @namespace('userContributor').Getter getUserById!: (id: Id | HashId) => Required<User>
  @namespace('userContributor').Action fetchUser!: (id: Id | HashId) => void
  get author(): Required<User> {
    return this.getUserById(this.post.author_hashid || this.post.author_id) || blankUser
  }

  get authorName(): string {
    return getAuthorDisplayName(this.author)
  }

  get authorProfileUrl(): string {
    return this.author.profile_url || ''
  }

  get isRegistered(): boolean {
    return isRegistered(this.author)
  }

  get publishedAt(): string | Date {
    return getPostPublishedAt(this.post)
  }

  mounted(): void {
    this.fetchUser(this.post.author_hashid || this.post.author_id)
  }
}
